<template>
  <v-app>
    <v-container fill-height>
      <v-row align="center" justify="center">
        <v-col cols="12" class="d-flex justify-center">
          <v-card class="sigfloCard" width="450">
            <v-card-text class="pt-4 textEmphasis sigfloBodyLarge text-center">
              {{ message }}
            </v-card-text>
            <v-card-actions class="d-flex justify-center">
              <v-btn dark rounded class="text-capitalize sigfloButtonSmall400 pr-4" color="#7C40DC" href="/"
                ><v-img class="sigfloLogo mx-2" src="@/assets/images/sigfloSymbolLogo.svg" height="32" width="32" />Lets
                get started!</v-btn
              >
            </v-card-actions>
          </v-card>
        </v-col>
      </v-row>
    </v-container>
  </v-app>
</template>

<script>
  export default {
    data() {
      return {
        message: ''
      };
    },
    mounted() {
      this.$store.dispatch('app/verifyEmail', this.$route.query.token).then((response) => {
        if (response && response.message) {
          this.message = response.message;
        } else {
          this.message = 'An error occurred while verifying your email.  Please try again.';
        }
      });
    }
  };
</script>

<style>
  .logoAvatar {
    position: absolute;
    top: -25px;
    left: 50%;
    transform: translateX(-50%);
  }
</style>
